import { render, staticRenderFns } from "./DeleteOrderModal.vue?vue&type=template&id=596d7722&"
import script from "./DeleteOrderModal.vue?vue&type=script&lang=js&"
export * from "./DeleteOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports